export const SET_TRIGGERS_TABLE_CALCULATION_CRITERIA = 'SET_TRIGGERS_TABLE_CALCULATION_CRITERIA';

export const setTriggersTableCalculationCriteria = calculationCriteria => {
  return {
    type: SET_TRIGGERS_TABLE_CALCULATION_CRITERIA,
    data: calculationCriteria,
  };
};
